import styled from '@emotion/styled';

export const SideMenuStyled = styled.div`
    width: 500px;
    max-width: 100%;
    box-sizing: border-box;
    height: calc(100vh - 12vh);
    max-height: calc(100vh - 12vh);
    min-height: 0;
    z-index: 11;

    padding: 0.8rem;
    .sideMenu {
        background-color: #41578f;
        color: white;
        height: 100%;
        border-radius: 10px;
        padding: 1.3rem 1.8rem;
    }

    .sideMenu--chat {
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
        padding-right: 1rem;
        padding-left: 1rem;
    }

    .conferenceChat {
        display: flex;
        flex-direction: column;
        flex: 1 1 0;
        min-height: 0;
    }

    .conferenceChat__messages {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overscroll-behavior: contain;
        padding: 0;
        background: #f5f5f5;
        border-radius: 8px;
    }

    .sideMenu--chat .conferenceChat .messageContainer {
        width: 100%;
        padding-right: 0.25rem;
        padding-left: 0.25rem;
    }

    .sideMenu--chat .conferenceChat .messageContainer .msg {
        max-width: 92%;
        min-width: 0;
    }

    .sideMenu--chat .conferenceChat .messageContainer.justifyEnd > .msg {
        width: fit-content;
    }

    .sideMenu--chat .conferenceChat .messageContainer .msg > .px-2 {
        min-width: 0;
        max-width: calc(100% - 2.5rem);
        padding-right: 0.25rem !important;
        padding-left: 0.25rem !important;
    }

    .sideMenu--chat .conferenceChat .messageContainer.justifyEnd > .msg > .px-2 {
        max-width: 100%;
    }

    .sideMenu--chat .conferenceChat .sent-msg {
        width: fit-content;
    }

    .sideMenu--chat .conferenceChat .sent-msg,
    .sideMenu--chat .conferenceChat .received-msg {
        max-width: 100%;
        overflow-wrap: anywhere;
    }

    .sideMenu--chat .conferenceChat .re-rp {
        color: #5c5d5d !important;
    }

    .conferenceChat__empty {
        padding: 1.5rem 0.25rem;
        color: #5c5d5d;
        text-align: center;
    }

    .conferenceChat__loadingOlder {
        position: sticky;
        top: 0;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        padding: 0.5rem;
        background: #f5f5f5;
        color: #5c5d5d;
        font-size: 1rem;
    }

    .conferenceChat__composer {
        width: 100%;
        max-width: none;
        margin: 0;
        padding-top: 0.75rem;
    }

    .conferenceChatInput {
        display: flex;
        align-items: flex-end;
        width: 100%;
        max-width: none;
        box-sizing: border-box;
        padding: 0.35rem 0.15rem;
        margin: 0;
        border-radius: 8px;
        background: #fff;
        box-shadow: 0 1px 3px rgba(25, 35, 55, 0.2);
    }

    .conferenceChatInput textarea {
        flex: 1 1 auto;
        min-width: 0;
        min-height: 2.75rem;
        max-height: 7rem;
        padding: 0.65rem 0.75rem;
        border: 0;
        outline: 0;
        resize: none;
        overflow-y: hidden;
        background: transparent;
        color: #30343b;
        font: inherit;
        line-height: 1.5;
    }

    .conferenceChatInput textarea::placeholder {
        color: #717780;
        opacity: 1;
    }

    .conferenceChatInput button {
        display: grid;
        flex: 0 0 2.75rem;
        width: 2.75rem;
        height: 2.75rem;
        place-items: center;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: transparent;
        color: #50aeb0;
        font-size: 2rem;
        cursor: pointer;
    }

    .conferenceChatInput button:disabled {
        opacity: 0.48;
        cursor: default;
    }

    .conferenceChatInput__spinner {
        color: #50aeb0;
        font-size: 2rem;
    }

    .conferenceChatInput button:focus-visible {
        outline: 2px solid #50aeb0;
        outline-offset: 2px;
    }

    @media (max-width: 900px) {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        width: min(92vw, 380px);
        height: auto;
        max-height: none;
        padding: 0.7rem;

        .sideMenu {
            height: 100%;
            overflow-y: auto;
        }

        .sideMenu--chat {
            overflow: hidden;
        }
    }
`;
